import { createPaginatedKey } from "api/keys";

export const orderGroupsKeys = {
  orderGroup: (id: string) => ["orderGroup", id],
  orderGroups: createPaginatedKey("orderGroups"),
  rampLoadingStatus: (id: string) => ["rampLoadingStatusForOrderGroup", id],
};
